/**
 * Resource Center JS
 *
 * @since 1.0.24
 */

(() => {
	// Lets get all the divs we need
	const postList = document.getElementById('as-rc-post-list');
	const noneFound = document.getElementById('as-rc-none');
	const loader = document.getElementById('as-rc-loader');
	const loadMoreContainer = document.getElementById('as-rc-get-more-btn');

	// Then the forms
	const tagSelectForm = document.getElementById('as-rc-tag-select');
	const catSelectForm = document.getElementById('as-rc-cat-select');

	// Check all of those, if any are missing lets send a console error
	if (!postList || !noneFound || !loader || !tagSelectForm || !catSelectForm || !loadMoreContainer) {
		console.error('Resource Centers missing elements');
		return;
	}


	/**
	 * Get Resources
	 * @param {string} excludedIds IDs to exclude from the query
	 * @param {boolean} loadMore If we are loading more resources
	 */
	const getResources = (excludedIds = '', loadMore = false) => {
		// First things first, lets hide the post list and none found then show the loader
		postList.classList.add('hidden');
		noneFound.classList.add('hidden');
		loader.classList.remove('hidden');

		// Lets get the selected tags
		const selectedTags = postList.getAttribute('data-selected-tags');

		// Lets get the selected category
		const selectedCats = postList.getAttribute('data-selected-categories');

		// Lets build formData to be sent to the server
		const formData = new FormData();
		formData.append('action', 'absencesoft_resource_center_get_resources');
		formData.append('tags', selectedTags);
		formData.append('categories', selectedCats);
		formData.append('exclude', excludedIds);

		// Lets fetch the resources
		fetch(ajaxurl, {
			method: 'POST',
			body: formData
		})
			.then(response => response.json())
			.then(data => {
				// First lets check for a data.success. If the key is missing or the value is false, alert the user and bail out
				if (!data.success) {
					console.error('No success key found in response');
					// Show the none page
					noneFound.classList.remove('hidden');
					loader.classList.add('hidden');

					// Hide the load more button
					loadMoreContainer.classList.add('hidden');

					// Log errors and bail
					console.error(data);
					return;
				}

				// Lets add the URL params if there are selected tags or categories
				const url = new URL(window.location.href);

				if (selectedTags) {
					url.searchParams.set('tags', selectedTags);

					// Now lets update the URL
					window.history.pushState({}, '', url);
				} else {
					// Remove the tags from the URL
					url.searchParams.delete('tags');

					// Now lets update the URL
					window.history.pushState({}, '', url);
				}

				if (selectedCats) {
					url.searchParams.set('categories', selectedCats);

					// Now lets update the URL
					window.history.pushState({}, '', url);
				} else {
					// Remove the categories from the URL
					url.searchParams.delete('categories');

					// Now lets update the URL
					window.history.pushState({}, '', url);
				}


				// Now lets check our resources value
				if (!data.data.resources) {
					// If there are no resources, lets show the none found div and hide the loader
					noneFound.classList.remove('hidden');
					loader.classList.add('hidden');

					// Hide the load more button
					loadMoreContainer.classList.add('hidden');

					return;
				}

				// Populate or append the resources to the post list
				if (loadMore) {
					// If we are loading more, lets append the new resources
					postList.innerHTML += data.data.resources;
				} else {
					// If we are not loading more, lets replace the resources
					postList.innerHTML = data.data.resources;
				}

				// Now lets show the post list and hide the loader
				postList.classList.remove('hidden');
				loader.classList.add('hidden');

				// Lastly, lets check the data.data.show_more_button value
				if (data.data.show_more_button) {
					// If the value is true, lets show the load more button
					loadMoreContainer.classList.remove('hidden');
				} else {
					// If the value is false, lets hide the load more button
					loadMoreContainer.classList.add('hidden');
				}

				// Stop the loader in the load more button
				const loadMoreIcon = loadMoreContainer.querySelector('span');
				loadMoreIcon.classList.remove('flex');
				loadMoreIcon.classList.add('hidden');
			})
			.catch(error => {
				// Console log the error
				console.error(error);

				// Show the none page
				noneFound.classList.remove('hidden');
				loader.classList.add('hidden');
			});
	};


	/**
	 * Load the initial resources
	 * @returns {void}
	 */
	const initLoad = () => {
		// Get the checked categories and checked tags
		const checkedCategories = catSelectForm.querySelectorAll('input:checked');
		const checkedTags = tagSelectForm.querySelectorAll('input:checked');

		// If both are empty, lets just get the resources
		if (!checkedCategories && !checkedTags) {
			getResources();
		}

		// We need to update both the data-selected-tags and data-selected-categories attributes in the post list so lets start looping
		let categories = [];

		checkedCategories.forEach(cat => {
			categories.push(cat.value);
		});

		let tags = [];

		checkedTags.forEach(tag => {
			tags.push(tag.value);
		});

		// Now lets populate the data-selected-tags and data-selected-categories attributes in the post list
		postList.setAttribute('data-selected-tags', tags.join(','));
		postList.setAttribute('data-selected-categories', categories.join(','));

		// Now lets get the resources
		getResources();
	};

	// Load
	initLoad();

	// Watch the tag select form
	tagSelectForm.addEventListener('change', (e) => {
		// Take the form and get all the checked inputs
		const checkedInputs = tagSelectForm.querySelectorAll('input:checked');

		// Lets loop and get the values
		let checkedValues = [];

		checkedInputs.forEach(input => {
			checkedValues.push(input.value);
		});

		// Lets join the array
		checkedValues = checkedValues.join(',');

		// Now lets set the data-selected-tags attribute in the post list
		postList.setAttribute('data-selected-tags', checkedValues);

		// Now lets get the resources
		getResources();

		// GTAG
		if (typeof gtag === 'function') {
			gtag('event', 'rc_tag_filter_click', {
				'event_category': 'Resource Center',
				'event_label': 'Tag Filter Click'
			});
		}
	});


	// Lets also watch the category select form
	catSelectForm.addEventListener('change', (e) => {
		// Take the form and get all the checked inputs
		const checkedInputs = catSelectForm.querySelectorAll('input:checked');

		// Lets loop and get the values
		let checkedValues = [];

		checkedInputs.forEach(input => {
			checkedValues.push(input.value);
		});

		// Lets join the array
		checkedValues = checkedValues.join(',');

		// Now lets set the data-selected-categories attribute in the post list
		postList.setAttribute('data-selected-categories', checkedValues);

		// Now lets get the resources
		getResources();

		// GTAG
		if (typeof gtag === 'function') {
			gtag('event', 'rc_cat_filter_click', {
				'event_category': 'Resource Center',
				'event_label': 'Category Filter Click'
			});
		}
	});


	// Lets also watch the get more button click
	const loadMoreButton = loadMoreContainer.querySelector('button');

	loadMoreButton.addEventListener('click', () => {
		// Lets get the current post list
		const currentPostListItems = document.querySelectorAll('.as-rc-post-list-item');

		// Loop through and get the data-resource-id
		let excludedIds = [];

		currentPostListItems.forEach(item => {
			excludedIds.push(item.getAttribute('data-resource-id'));
		});

		// If there is any excluded ids, lets join them
		excludedIds = excludedIds.join(',');

		// Show the loader in the load more button
		loadMoreIcon = loadMoreButton.querySelector('span');
		loadMoreIcon.classList.remove('hidden');
		loadMoreIcon.classList.add('flex');

		// Now lets run a getResources with the excluded ids
		getResources(excludedIds, true);

		// GTAG
		if (typeof gtag === 'function') {
			gtag('event', 'rc_load_more_click', {
				'event_category': 'Resource Center',
				'event_label': 'Load More'
			});
		}
	});


	// Here we can handle the filters on mobile
	const filtersExpandButton = document.getElementById('as-rc-expand-filters-button');

	// If the button exists lets listen in
	if (filtersExpandButton) {
		filtersExpandButton.addEventListener('click', () => {
			// Get the filters container
			const filtersContainer = document.getElementById('as-rc-filters-cont');

			// If the container exists, lets toggle the class
			if (filtersContainer) {
				filtersContainer.classList.toggle('max-h-0');

				// Change the inner text of the button
				if (filtersContainer.classList.contains('max-h-0')) {
					filtersExpandButton.innerText = 'Show Filters';
				} else {
					filtersExpandButton.innerText = 'Hide Filters';
				}
			}

			// GTAG
			if (typeof gtag === 'function') {
				gtag('event', 'rc_mobile_filters_click', {
					'event_category': 'Resource Center',
					'event_label': 'Mobile Filters Toggle Expand Click'
				});
			}
		});
	}

})();